/**
 *
 * Global
 *
 * Global constants
 *
 * @author     K. van den Broek <k.vandenbroek@uselab.com>
 * @copyright  Uselab Amsterdam
 *
 */

import httpHelper from 'shared/helpers/http';

const DOMAIN = process.env.VUE_APP_DOMAIN || httpHelper.getDomain();
const API_URL = process.env.VUE_APP_API_URL || `${DOMAIN}/api`;
const LOCAL_STORAGE = process.env.VUE_APP_LOCAL_STORAGE || 'awd';
const LOCAL_STORAGE_AUTH_KEY = 'auth';

export default {
  DOMAIN,
  API_URL,
  LOCAL_STORAGE,
  LOCAL_STORAGE_AUTH_KEY
};
